import { defineStore } from "pinia";
import { computed, ref } from "vue";

import type { License, LicenseType } from "@/model/session";
import { asReadonly } from "@/utils/vue";

import { useUserStore } from "./user";

export const useLicenseStore = defineStore(
  "license",
  () => {
    const license = ref<License>({
      daysTillExpiration: null,
      usable: true,
      plan: "standard",
      tracking: false,
      type: "trial",
      onPrem: false,
    });

    const isExpired = computed(() => {
      const expire = license.value.daysTillExpiration;
      return expire !== null && expire <= 0;
    });

    const willExpireIn = computed(() => {
      const expire = license.value.daysTillExpiration;
      return expire !== null && expire < 30 && expire > 0 ? expire : undefined;
    });

    function setLicense(e: {
      validDays: number;
      plan: License["plan"];
      tracking: boolean;
      type: LicenseType;
      onPrem: boolean;
    }) {
      license.value.daysTillExpiration = e.validDays;
      license.value.usable = e.validDays >= 0 || useUserStore().isAllowed("useWithoutLicense");
      license.value.plan = e.plan;
      license.value.tracking = e.tracking;
      license.value.type = e.type;
      license.value.onPrem = e.onPrem;
    }

    return { license: asReadonly(license), isExpired, willExpireIn, setLicense };
  },
  { autoReset: true },
);
